module.exports = __webpack_public_path__ + "img/AccuFFRoct_Series.58347f8d.png";